"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceError = void 0;
const axios_1 = require("axios");
class ServiceError {
    constructor(error) {
        if ((0, axios_1.isAxiosError)(error)) {
            this.message = error.response ? error.response.statusText : error.message;
            this.status = error.status;
            this.stack = error.stack;
        }
        else if (error instanceof Error) {
            console.log("error.name", error.name);
            this.message = error.message;
            this.stack = error.stack;
        }
        else {
            this.message = error;
        }
    }
}
exports.ServiceError = ServiceError;
